import React from 'react';
import { Loader2 } from 'lucide-react';

import { cn } from '../lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** Visible caption next to the spinner; also announced to screen readers. */
  label?: string;
  className?: string;
}

const SIZE_CLASSES: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

/**
 * The portal's one inline spinner. Full-screen and in-button uses compose it;
 * data surfaces should prefer Skeleton (first load) or dimming (refetch).
 */
export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', label, className }) => (
  <span role="status" className={cn('inline-flex items-center gap-2 text-muted-foreground', className)}>
    <Loader2 aria-hidden="true" className={cn('animate-spin', SIZE_CLASSES[size])} />
    {label ? <span className="text-sm">{label}</span> : <span className="sr-only">Loading</span>}
  </span>
);

/** Centered spinner for auth-boundary and whole-page waits only. */
export const FullPageSpinner: React.FC<{ label?: string }> = ({ label = 'Loading…' }) => (
  <div className="flex min-h-screen items-center justify-center bg-background">
    <Spinner size="lg" label={label} />
  </div>
);
